// Tracks the currencies a user has recently picked (most-recent first).
const KEY = "sliply_recent_currencies";
const MAX = 4;

export function getRecentCurrencies() {
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(arr) ? arr.filter((c) => typeof c === "string") : [];
  } catch {
    return [];
  }
}

export function pushRecentCurrency(code) {
  if (!code) return;
  try {
    const next = [code, ...getRecentCurrencies().filter((c) => c !== code)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore storage errors */
  }
}
